import { Setting, SettingsSection } from "./Settings"

export default function DeviceSettings() {
    return <SettingsSection title="Device">
        <Setting title="Allow secondary login auto-completion" description="Allow tablet secondary login dialogs to auto-complete the users email address."
            name="allow_secondary_login_auto_complete"
            overrideName="allow_secondary_login_auto_complete" defaultValue={false}/>
    </SettingsSection>
}
